import axiosInstance from '../../../config/axiosInstance';
import type { PVProfile, PVProfileWrite } from '../types/projectVitalProfile';

export async function getPVProfile(): Promise<PVProfile> {
  const { data } = await axiosInstance.get('/project-vital/profile');
  return data as PVProfile;
}

export async function updatePVProfile(payload: PVProfileWrite): Promise<PVProfile> {
  const { data } = await axiosInstance.put('/project-vital/profile', payload);
  return data as PVProfile;
}
